import React, { useEffect, useState } from "react";
import { useIframeUrlMutation } from "../../app/services/DashBoard/adminDashBoardApi";
import Select from "react-select";

const MetaBaseDashBoardThree = () =>
{
  const [ iframeUrl, setIframeUrl ] = useState( "" );
  const [ loading, setLoading ] = useState( true );
  const [ error, setError ] = useState( "" );

  // Filter states
  const currentYear = () => new Date().getFullYear().toString();
  const [ applicationType, setApplicationType ] = useState( "" );
  const [ subscriptionYear, setSubscriptionYear ] = useState( "" );
  const [ sufficientCPDFilter, setSufficientCPDFilter ] = useState( "" );
  const [ selectedStartYear, setSelectedStartYear ] = useState( "" );
  const [ selectedEndYear, setSelectedEndYear ] = useState( "" );

  const years = Array.from({ length: 11 }, (_, i) => { const year = (2020 + i).toString();
    return { value: year, label: year };
  });


  const [ iframeUrlApi ] = useIframeUrlMutation();

  const fetchIframeUrl = async () =>
  {
    setLoading( true );
    setError( "" );

    try
    {
      const requestPayload = {
        questionId: 43,
        params: {
          applicationType: applicationType || null,
          subscriptionStatus: subscriptionYear || null,
          SufficientCPDFilter: sufficientCPDFilter || null,
          StartYear: selectedStartYear || null,
          EndYear: selectedEndYear || null,
        },
        expMinutes: 10,
        bordered: true,
        titled: true,
      };

      const response = await iframeUrlApi( requestPayload ).unwrap();
      setIframeUrl( response.iframeUrl );
    } catch ( err )
    {
      console.error( err );
      setError( "Failed to fetch iframe URL" );
    } finally
    {
      setLoading( false );
    }
  };

  // Load all data initially
  useEffect( () =>
  {
    fetchIframeUrl();
  }, [] );

  const resetForm = () =>
  {
    setApplicationType( "" );
    setSubscriptionYear( "" );
    setSufficientCPDFilter( "" );
    setSelectedStartYear( "" );
    setSelectedEndYear( "" )
    fetchIframeUrl();
  }

  return (
    <div style={ { padding: "20px", position: "relative" } }>
      <button
        onClick={ resetForm }
        class="btn success-btn reload-btn"
        disabled={ loading }
        style={ {
          cursor: loading ? "not-allowed" : "pointer",
        } }
      >
        { loading ? "Loading..." : "Reload Report" }
      </button>

      {/* Filter Inputs */ }
      <div className="filter-input iframe-card">
        <div>
          <label style={ { display: "block", marginBottom: "4px" } }>Application Type</label>
          <select
            value={ applicationType }
            onChange={ ( e ) => setApplicationType( e.target.value ) }
            style={ { padding: "6px", borderRadius: "4px", border: "1px solid #ccc" } }
          >
            <option value="">-- Select --</option>
            <option value="GMA">GMA</option>
            <option value="GMAP">GMAP</option>
            <option value="GMAAP">GMAAP</option>
          </select>
        </div>
     
        <div className="custom-select-for-metabase">
          <label style={ { display: "block", marginBottom: "4px" } }>
            Start Year
          </label>

          <Select
            value={years.find(y => y.value === selectedStartYear) || null}
            onChange={(option) => setSelectedStartYear(option.value)}
            options={years}
            styles={{
              menu: (base) => ({
                ...base,
                maxHeight: 160,     
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: 160,
                overflowY: "auto", 
              }),
            }}
          />
        </div>
        <div className="custom-select-for-metabase">
          <label style={ { display: "block", marginBottom: "4px" } }>
            End Year
          </label>

          <Select
            value={years.find(y => y.value === selectedEndYear) || null}
            onChange={(option) => setSelectedEndYear(option.value)}
            options={years}
            styles={{
              menu: (base) => ({
                ...base,
                maxHeight: 160,     
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: 160,
                overflowY: "auto", 
              }),
            }}
          />
        </div>
       
        <div>
          <label style={ { display: "block", marginBottom: "4px" } }>
            Subscription Status
          </label>
          <select
            value={ subscriptionYear }
            onChange={ ( e ) => setSubscriptionYear( e.target.value ) }
            style={ {
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            } }
          >
            <option value="">-- Select --</option>
            <option value="1">Active</option>
            <option value="2">Inactive</option>
            <option value="3">Expired</option>
            <option value="4">Terminated</option>
          </select>
        </div>

        <div>
          <label style={ { display: "block", marginBottom: "4px" } }>Sufficient CPD Filter</label>
          <select
            value={ sufficientCPDFilter }
            onChange={ ( e ) => setSufficientCPDFilter( e.target.value ) }
            style={ { padding: "6px", borderRadius: "4px", border: "1px solid #ccc" } }
          >
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>

        <button
          onClick={ fetchIframeUrl }
          disabled={ loading }
          style={ {
            backgroundColor: "#ff8c00",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: loading ? "not-allowed" : "pointer",
            alignSelf: "flex-end",
          } }
        >
          { loading ? "Loading..." : "Fetch" }
        </button>
      </div>

      { error && <p style={ { color: "red" } }>{ error }</p> }

      { iframeUrl && (
        <iframe
          src={ iframeUrl }
          width="100%"
          height="600"
          frameBorder="0"
          style={ { marginTop: "20px", borderRadius: "8px" } }
          title="Metabase Report"
        />
      ) }
    </div>
  );
};

export default MetaBaseDashBoardThree;
